import JsFileDownloader from 'js-file-downloader'

import * as AuthStore from '@store/auth/auth'

import axios from 'axios'

import config from '@app/config'

const exporter = {
  download: <T>(
    url: string,
    name: string,
    type: 'application/vnd.ms-excel' | 'application/pdf',
    body?: T
  ): Promise<void> => {
    const { tokens } = AuthStore.store.getState()

    if (!tokens) {
      return Promise.reject('no tokens provided')
    }

    const downloader = new JsFileDownloader({
      url,
      method: body ? 'POST' : 'GET',
      contentType: 'application/json',
      headers: [
        { name: 'authorization', value: `Bearer ${tokens.access}` },
        { name: 'accept', value: type },
      ],
      body: body ? JSON.stringify(body) : undefined,
      autoStart: false,
      filename: name,
    })

    return downloader.start().catch((err) => {
      if (!err || !err.request) {
        throw err
      }

      const { status } = err.request

      if (status === 401) {
        return retryOrThrow<T>(url, name, type, body).catch(() => {
          // Authentication or right error and max retry reached
          throw new Error('Expired session ?')
        })
      }

      throw err
    })
  },
}

const retryOrThrow = <T>(url: string, name: string, type: 'application/vnd.ms-excel' | 'application/pdf', body?: T) => {
  const { tokens } = AuthStore.store.getState()

  if (!tokens) {
    return Promise.reject('no tokens provided')
  }

  return axios
    .request<LoginRefreshSuccessResponse>({
      url: config.ws.authentification.refresh,
      method: 'PUT',
      data: { refresh_token: tokens.refresh },
    })
    .then((res) => res.data)
    .then((refreshed) => {
      // save new tokens before retry call
      AuthStore.actions.setTokens({
        access: refreshed.access_token,
        expireIn: refreshed.expires_in,
        scopes: refreshed.scopes,
        refresh: tokens.refresh,
      })
    })
    .then(() => exporter.download<T>(url, name, type, body))
}

export default exporter
